import { render } from "./MarkdownEditor.vue?vue&type=template&id=2a8d9a72&ts=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=ts"
export * from "./MarkdownEditor.vue?vue&type=script&lang=ts"

import "./MarkdownEditor.vue?vue&type=style&index=0&id=2a8d9a72&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__